import { WebGLRenderer, LinearFilter, RGBAFormat, SRGBColorSpace, WebGLRenderTarget } from 'three';
import Sizes from '../utils/Sizes.js';
//import GlitchPass from './GlitchPass.js';

export default class Renderer {
    constructor(canvas) {
        // Singleton pattern
        if (Renderer.instance) {
            return Renderer.instance;
        }
        Renderer.instance = this;

        // Setup
        this.canvas = canvas;
        this.sizes = Sizes.getInstance();
        //this.glitchPass = GlitchPass.getInstance();
        
        // Create renderer
        this.renderer = new WebGLRenderer({
            canvas: this.canvas,
            antialias: true
        });
        this.renderer.setClearColor(0x000000);
        this.renderer.setPixelRatio(this.sizes.pixelRatio);
        this.renderer.setSize(this.sizes.width, this.sizes.height);
        
        this.initRenderTarget();

        this.sizes.on('resize', () => {
            this.renderer.setSize(this.sizes.width, this.sizes.height);
            this.renderer.setPixelRatio(this.sizes.pixelRatio);
            this.renderTarget.setSize(this.sizes.width, this.sizes.height);
        });
    }

    // Static method to get the instance
    static getInstance(canvas) {
        if (!Renderer.instance) {
            Renderer.instance = new Renderer(canvas);
        }
        return Renderer.instance;
    }

    renderBackground(backgroundScene, cameraBackground) {
        this.renderer.setRenderTarget(this.renderTarget);
        this.renderer.render(backgroundScene, cameraBackground);
    }

    renderForeground(foregroundScene, cameraForeground) {
        //this.renderer.setRenderTarget(this.glitchPass.getRenderTarget());
        this.renderer.setRenderTarget(null);
        this.renderer.render(foregroundScene, cameraForeground);

        /*
        const renderedTexture = this.glitchPass.getRenderTarget().texture;

        this.glitchPass.setTexture(renderedTexture);
        this.renderer.setRenderTarget(null);
        this.renderer.render(this.glitchPass.getScene(), this.glitchPass.getCamera());
        */
    }

    initRenderTarget() {
        this.renderTarget = new WebGLRenderTarget(
            this.sizes.width, 
            this.sizes.height, 
            {
                minFilter: LinearFilter,
                magFilter: LinearFilter,
                format: RGBAFormat,
                colorSpace: SRGBColorSpace,
            }
        );
    }

    getRenderedTexture() {
        return this.renderTarget.texture;
    }
} 